import Api from '../Base'

class GetProductBySKU extends Api {
  requestUrl = `/api/Product`
}

export default GetProductBySKU
